/**
 * Yetkisiz erişim paneli.
 *
 * NİÇİN AYRI BİLEŞEN: eski sistemde yetkisiz kullanıcı sessizce `index.php`'ye
 * atılıyordu — neden atıldığını anlamıyor, şifresini yanlış girdiğini sanıyordu.
 * Artık nedeni yazıyoruz.
 *
 * Bu YALNIZCA kullanılabilirlik katmanıdır; gerçek koruma her zaman Security
 * Rules ve Cloud Function guard'larındadır.
 */
export function NoAccess({
  what = "Bu sayfa",
  hint,
}: {
  /** Neye erişilemediği. ör. "Maliyet bilgisi" */
  what?: string;
  /** Kime sorulacağı gibi ek yönlendirme. */
  hint?: string;
}) {
  return (
    <div
      role="status"
      className="rounded-lg border border-amber-200 bg-amber-50 p-6 text-center"
    >
      <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
        <svg
          className="h-5 w-5 text-amber-700"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <p className="text-sm font-medium text-amber-900">{what} için yetkiniz yok.</p>
      <p className="mt-1 text-sm text-amber-800">
        {hint ?? "Erişim gerekiyorsa iş sahibinden yetki isteyin."}
      </p>
    </div>
  );
}

export default NoAccess;
